export default __webpack_public_path__ + "static/media/pdc_meeting_icon.37453d05.svg";